module.exports = __webpack_public_path__ + "img/mainImg3.636ff108.jpg";